import { makeStyles } from '@mui/styles';
import { Tooltip } from '@mui/material';

const useStyles = makeStyles(() => ({
    arrow: {
        color: '#fff',
    },
    tooltip: {
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: '0 1px 8px rgba(0, 0, 0, 0.12)',
        fontSize: 12,
        maxWidth: 400,
        whiteSpace: 'pre-wrap',
    },
}));

function LightTooltip(props) {
    const classes = useStyles();
    const { title, children, ...otherProps } = props;

    if (!title ||
        (typeof title === 'string' && title.trim() === '') ||
        (typeof title === 'object' && title !== null && Object.keys(title).length === 0) ||
        (title && title.props && typeof title.props.children === 'string' && title.props.children.trim() === '')) {
        return children;
    }

    return (
        <Tooltip
            classes={classes}
            title={title}
            {...otherProps}
        >
            {children}
        </Tooltip>
    );
}

/**
 * @param {{children: *} & import('@mui/material').TooltipProps} param0
 */
const CustomizedTooltip = ({ children, ...rest }) => (
    <LightTooltip {...rest}>
        {children}
    </LightTooltip>
);

export default CustomizedTooltip;
